// extracted by mini-css-extract-plugin
export default {"tag":"_5Y6dEn78Ve"};